import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { delay, pick, filter } from 'lodash';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
// Legacy constraints for reference:
// const constraints = {
//   name: {
//     presence: true,
//   },
// };
import Joi from 'joi';
import { 
  Modal, Button, FormGroup, ControlLabel, FormControl,
  HelpBlock, Tooltip, OverlayTrigger,
} from 'react-bootstrap';
import { cleanSubmitCriteria, getSavedSearches } from './search-form-reducer';
import { doSaveSearch, updateSaveSearch, loadSaveSearch } from './search-form-actions';
import AlertIcon from '../alert-icon';

class SaveSearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      success: false,
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  open() {
    this.props.initialize(this.props.savedSearch);
    this.setState({ open: true, success: false });
    this.props.onModalShow();
  }

  close() {
    const { success } = this.state;
    this.setState({ open: false });
    delay(() => {
      this.setState({ success: false });
    }, 500);
    if (success) {
      this.props.onCreate();
    }
    this.props.onModalHide();
  }

  handleSubmit(data) {
    const { type } = this.props;
    const params = pick(data, ['name', 'description', 'criteria', 'context', 'type']);
    params.criteria = cleanSubmitCriteria(params.criteria);
    
    const existentId = data.existent_id;
    let isUpdate = false;
    let searchId = null;
    const isOverride = existentId !== '0' && existentId !== undefined && existentId !== null;

    if (isOverride) {
      isUpdate = true;
      searchId = existentId;
      params.teamId = this.props.teamId;
    } else if (data._id) {
      isUpdate = true;
      searchId = data._id;
      params.teamId = data.team__id;
    }
    if (!isUpdate) {
      params.teamId = this.props.teamId;
    }
    const action = isUpdate ? updateSaveSearch(type, searchId, params) : doSaveSearch(type, params);
    const p = this.props.dispatch(action);
    p.then(
      (search) => {
        if (isUpdate && !isOverride) {
          this.close();
          return;
        }
        this.props.dispatch(loadSaveSearch(type, search._id))
          .then(
            () => {
              this.setState({ success: true });
            },
            () => {
              this.setState({ success: true });
            },
          );
      },
      (errors) => {
        throw new SubmissionError(errors.data || errors);
      },
    );
    return p;
  }

  renderField({
    input, label, type, componentClass, meta: { touched, error }, options,
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        {componentClass === 'select' &&
          <FormControl {...input} componentClass={componentClass} placeholder={label} type={type} disabled={submitting}>
            {options.map(o => (<option key={o._id} value={o._id}>{o.name}</option>))}
            <option value="0">Create a new filter set</option>
          </FormControl>
        }
        {componentClass !== 'select' &&
          <FormControl {...input} componentClass={componentClass} placeholder={label} type={type} disabled={submitting} />
        }
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderCreateForm() {
    const {
      handleSubmit, submitting, valid, savedSearch,
      savedSearches, existentId,
    } = this.props;
    const isNew = savedSearch._id === undefined;
    const isCreate = existentId === '0';
    const currentSavedSearches = filter(savedSearches, ss => ss.is_my_search && ss.is_automation !== true && ss.is_system !== true);

    const cls = currentSavedSearches.length > 0 && isCreate ? 'well' : null;
    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Modal.Body>
          {currentSavedSearches.length > 0 &&
            <Field
              name="existent_id"
              componentClass="select"
              component={this.renderField}
              label="Select a filter set"
              options={currentSavedSearches}
            />
          }
          <div className={cls}>
            {currentSavedSearches.length > 0 && !isCreate &&
              <div className="alert alert-warning"><Fa name="exclamation-triangle" /> This will update the currect selected filter set</div>
            }
            {isNew && isCreate &&
              <div className="alert alert-success">
                Save this current filter set so that your can prefill the search form later.
              </div>
            }

            {isCreate &&
              <Field
                name="name"
                type="text"
                component={this.renderField}
                label="Filter Set Name"
              />
            }
            {isCreate &&
              <Field
                name="description"
                componentClass="textarea"
                component={this.renderField}
                label="Description"
              />
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button bsStyle="link" className="pull-left" disabled={submitting} onClick={this.close}>
              Cancel
            </Button>
            <Button bsStyle="primary" disabled={submitting || !valid} type="submit">
              {!submitting &&
                <span>
                  {isNew && <span>Save</span>}
                  {!isNew && <span>Update</span>}
                </span>
              }
              {submitting && <span><Fa name="spinner" spin /> Saving</span>}
            </Button>
          </div>
        </Modal.Footer>
      </form>
    );
  }

  renderEditForm() {
    const {
      handleSubmit, submitting, valid,
    } = this.props;
    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Modal.Body>
          <Field
            name="name"
            type="text"
            component={this.renderField}
            label="Filter Set Name"
          />
          <Field
            name="description"
            componentClass="textarea"
            component={this.renderField}
            label="Description"
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button bsStyle="link" className="pull-left" disabled={submitting} onClick={this.close}>
              Cancel
            </Button>
            <Button bsStyle="primary" disabled={submitting || !valid} type="submit">
              {!submitting && <span>Update</span>}
              {submitting && <span><Fa name="spinner" spin /> Saving</span>}
            </Button>
          </div>
        </Modal.Footer>
      </form>
    );
  }

  renderModal() {
    const { open, success } = this.state;
    const { submitting, savedSearch } = this.props;

    const isNew = savedSearch._id === undefined;
    return (
      <Modal show={open} bsSize={success ? 'sm' : null} onHide={this.close}>
        <Modal.Header closeButton>
          {isNew && <Modal.Title>Save Filter Set</Modal.Title>}
          {!isNew && <Modal.Title>Update Filter Set</Modal.Title>}
        </Modal.Header>
        {!success && isNew && this.renderCreateForm()}
        {!success && !isNew && this.renderEditForm()}
        {success &&
          <div>
            <Modal.Body>
              <div className="text-center">
                <AlertIcon />
                <p>Filter set has been saved!</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle="primary"
                bsSize="lg"
                block
                disabled={submitting}
                onClick={this.close}
              >
                Done
              </Button>
            </Modal.Footer>
          </div>
        }
      </Modal>
    );
  }

  render() {
    const {
      disabled, children, bsStyle, bsSize,
      tooltip,
    } = this.props;
    let comp = (
      <Button
        disabled={disabled}
        bsStyle={bsStyle}
        bsSize={bsSize}
        onClick={this.open}
      >
        {children}
      </Button>
    );
    if (tooltip) {
      const tip = (
        <Tooltip id="saved-search-edit-tip">
          <div>{tooltip}</div>
        </Tooltip>
      );
      comp = (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          {comp}
        </OverlayTrigger>
      );
    }
    return (
      <span>
        {this.renderModal()}
        {comp}
      </span>
    );
  }
}

SaveSearchForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCreate: PropTypes.func,
  valid: PropTypes.bool.isRequired,
  onModalShow: PropTypes.func,
  onModalHide: PropTypes.func,
  savedSearch: PropTypes.shape({
    _id: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  children: PropTypes.node,
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  tooltip: PropTypes.string,
  savedSearches: PropTypes.arrayOf(PropTypes.shape({})),
  existentId: PropTypes.string,
  teamId: PropTypes.string,
  type: PropTypes.string.isRequired,
};
SaveSearchForm.defaultProps = {
  onModalShow: () => {},
  onModalHide: () => {},
  savedSearch: {},
  onCreate: () => {},
  savedSearches: [],
  disabled: false,
  children: (<span>Save Filter Set</span>),
  bsStyle: 'link',
  bsSize: null,
  tooltip: null,
  existentId: null,
  teamId: null,
};

SaveSearchForm.contextTypes = {
};


const validate = (values) => {
  const schema = Joi.object({
    name: Joi.string().required().messages({
      'string.base': 'Name must be a string',
      'string.empty': 'Name is required',
      'any.required': 'Name is required',
    }),
  }).unknown(true);
  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};
const selector = formValueSelector('saveSearchForm'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const existentId = selector(state, 'existent_id');
  const savedSearches = getSavedSearches(ownProps.type, state);
  return {
    savedSearches,
    existentId,
  };
}

const SaveSearchFormForm = reduxForm({
  form: 'saveSearchForm',
  validate,
})(SaveSearchForm);

export default connect(mapStateToProps)(SaveSearchFormForm);
